<template>
  <v-chip
    t-data="status-chip"
    :text-color="statusTextColor(status)"
    :color="statusFillColor(status)"
    dark
  >
    {{ statusName(status) }}
  </v-chip>
</template>

<script>
import {digitalProductStatus} from '@/constants/digital-product'

export default {
  name: 'VoucherStatusChip',
  props: {
    status: {type: String}
  },
  methods: {
    statusTextColor(status) {
      if (status === 'NEW') return 'info800Color'
      if (status === 'REDEEMED') return 'warning800Color'
      if (status === 'USED') return 'success800Color'
      if (status === 'EXPIRED') return 'danger700Color'
      if (status === 'REFUNDED') return 'primaryTextColor'
    },
    statusFillColor(status) {
      if (status === 'NEW') return 'info200Color'
      if (status === 'REDEEMED') return 'warning400Color'
      if (status === 'USED') return 'success300Color'
      if (status === 'EXPIRED') return 'danger300Color'
      if (status === 'REFUNDED') return 'failChip'
    },
    statusName(status) {
      const listStatus = Object.entries(digitalProductStatus).map(s => ({value: s[0], name: s[1]}))
      const selectedStatus = listStatus.filter(s => s.value === status)
      if (selectedStatus.length > 0) return selectedStatus[0].name
      return status
    },
  }
}
</script>
<style lang="sass" scoped>
</style>
